/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
  Accordion,
  Tab,
  Menu,
  Divider,
  Grid,
  Segment,
  Label
} from 'semantic-ui-react';
import shortid from 'short-id';
import qs from 'qs';
import * as AppActions from '../../../actions';
import {
  buildAdPreviewObjectCompare,
  getEventSourceGroupName,
  sortAdsBy,
  getAdTypeOfAd
} from '../../../utils/ad.common';
import {
  restructureCampaign,
  restructureAdQc,
  getGeneralQcProgess,
  adPatterns
} from '../../../utils/campaignRestructuring';
import { updateUrl } from '../../../utils/urls';
import domains from '../../../containers/Domains';
import AdQCProgressBar from './AdQCProgressBar';
import TabTotalAds from './TabTotalAds';
import WrapperTabCheckbox from './WrapperTabCheckbox';
import PreviewAccordionItem from './PreviewAccordionItem';
import AdPreviewMultiQc from './AdPreviewMultiQc';
import AdPreviewLoader from '../../../components/common/AdPreviewLoader';
import CampaignTagsContainer from './CampaignTagsContainer';
import ToggleComponents from './ToggleComponents';
import AdPreviewCommonToolsSidebar from './AdPreviewCommonToolsSidebar';

const { featureFlags } = domains || {};
const { adPreview: adPreviewFlagObj } = featureFlags || {};
const { campaignRestructuringEnabled } = adPreviewFlagObj || {};

class TabCampaignsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignMonth: props.campaignMonth,
      processing: true,
      loaderCount: 0,
      activeIndex: 0,
      campaignKey: '',
      showNoAdWarning: false,
      eventGroupNames: null,
      campaignRestructured: false,
      desktopUrl: null,
      mobileUrl: null,
      indexToUpdate: -1
    };
  }

  componentDidMount() {
    this.processingCampaign();
    document
      .querySelector('.App-content')
      .addEventListener('scroll', this.toggleScrollButton);
  }

  componentWillUnmount() {
    const { showCheckboxes, showCheckboxesMultiQc, actions } = this.props;
    window.removeEventListener('scroll', this.toggleScrollButton);
    this.resetReduxSelectedAds();
    if (showCheckboxes) actions.displayCustomCheckbox();
    if (showCheckboxesMultiQc) actions.displayMultiQcCheckbox();
  }

  shouldComponentUpdate(nextProps) {
    const { showCheckboxesMultiQc, showCheckboxes, selectedAds } = this.props;
    const {
      showCheckboxesMultiQc: nextshowCheckboxesMultiQc,
      showCheckboxes: nextShowCheckboxes,
      selectedAds: nextSelectedAds
    } = nextProps;

    const flattenedSelectedAds = this.flattenSelectedAds(selectedAds);
    const nextFlattenSelectedAds = this.flattenSelectedAds(nextSelectedAds);
    const sameSelectedAdsLength =
      flattenedSelectedAds.length === nextFlattenSelectedAds.length;
    if (
      showCheckboxes !== nextShowCheckboxes ||
      showCheckboxesMultiQc !== nextshowCheckboxesMultiQc ||
      sameSelectedAdsLength
    ) {
      return false;
    }
    return true;
  }

  flattenSelectedAds = (selectedAds) => {
    const keys = Object.keys(selectedAds);
    let flattenedArray = [];
    keys.forEach((key) => {
      flattenedArray = flattenedArray.concat(selectedAds[key]);
    });
    return flattenedArray;
  };

  finishProcessing = () => {
    this.setState({ processing: false });
  };

  restructureCampaignsOnMount = () => {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    const { campaign } = params || {};

    const foundRestructuredCampaignKey = this.checkIfCampaignIsRestructured(
      campaign
    );

    if (foundRestructuredCampaignKey) {
      this.restructureCampaigns();
    } else {
      const { campaignMonth } = this.state;
      this.processUpdatedQcForAllCampaigns(campaignMonth);
    }
    this.getTabActive();
    this.updateSelectedAds();
    this.finishProcessing();
  };

  checkIfCampaignIsRestructured = (campaignKey) => {
    const restructuredCampaignKeys = [
      'MODEL_BASED',
      'DEALERSHIP_BRANDING',
      'OFFERS'
    ];
    const foundRestructuredCampaignKey =
      restructuredCampaignKeys.findIndex((key) => {
        return campaignKey === key;
      }) !== -1;
    return foundRestructuredCampaignKey;
  };

  resetReduxSelectedAds = () => {
    let { checkedCampaigns, indeterminateCampaigns } = this.props;
    const { actions, selectedAds } = this.props;
    const { campaignMonth } = this.state;
    const campaignKeys = Object.keys(campaignMonth);
    checkedCampaigns = {};
    indeterminateCampaigns = {};
    campaignKeys.forEach((key) => {
      selectedAds[key] = [];
      checkedCampaigns[key] = false;
      indeterminateCampaigns[key] = false;
    });

    actions.updateAdPreviewData(
      selectedAds,
      checkedCampaigns,
      indeterminateCampaigns
    );
  };

  selectAllAdsInRedux = () => {
    let { selectedAds, checkedCampaigns, indeterminateCampaigns } = this.props;
    const { actions } = this.props;
    const { campaignMonth } = this.state;
    const campaignKeys = Object.keys(campaignMonth);
    checkedCampaigns = {};
    selectedAds = {};
    indeterminateCampaigns = {};
    campaignKeys.forEach((key) => {
      selectedAds[key] = campaignMonth[key];
      checkedCampaigns[key] = true;
      indeterminateCampaigns[key] = false;
    });
    campaignKeys.forEach((key) => {
      selectedAds[key].forEach((ad) => {
        const currentAd = ad;
        currentAd.id = ad.ad_id;
      });
    });
    actions.updateAdPreviewData(
      selectedAds,
      checkedCampaigns,
      indeterminateCampaigns
    );
  };

  restructureCampaigns = () => {
    const { campaignMonth, campaignRestructured } = this.state;
    const {
      actions,
      adAccountName,
      selectedYear,
      campaignMonthName,
      showCheckboxes,
      showCheckboxesMultiQc,
      campaignMonth: campaignMonthProp,
      allAdsExpanded
    } = this.props;

    if (showCheckboxes) actions.displayCustomCheckbox();
    if (showCheckboxesMultiQc) actions.displayMultiQcCheckbox();

    this.resetReduxSelectedAds();
    const campaignNotRestructured = !campaignRestructured;
    let newCampaignMonth = {};
    if (campaignNotRestructured) {
      const {
        campaignMonth: restructuredCampaignMonth,
        qcProcess: newQcProcess,
        generalQcProgress: newGeneralQcProcess
      } = restructureCampaign(campaignMonth) || {};
      newCampaignMonth = restructuredCampaignMonth;
      actions.updateTotalQCAds(newQcProcess, newGeneralQcProcess);
    } else {
      newCampaignMonth = campaignMonthProp;
      const revertedQcProcess = restructureAdQc(newCampaignMonth);
      const revertedGeneralQcProgess = getGeneralQcProgess(revertedQcProcess);
      actions.updateTotalQCAds(revertedQcProcess, revertedGeneralQcProgess);
    }
    const newCampaignKeys = Object.keys(newCampaignMonth);
    updateUrl(
      adAccountName,
      selectedYear,
      campaignMonthName,
      '',
      newCampaignKeys[0], // use first tab for now
      '',
      allAdsExpanded || 'false'
    );
    this.setState(
      (prevState) => ({
        ...prevState,
        campaignMonth: newCampaignMonth,
        campaignRestructured: !campaignRestructured
      }),
      () => {
        this.resetReduxSelectedAds();
        this.selectAllAdsInRedux();
      }
    );
  };

  getTabActive = () => {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    const campaignMonth = this.state.campaignMonth;
    const { campaignRestructured } = this.state;
    const campaignList = campaignRestructured
      ? {
          MODEL_BASED: 'Model Ads',
          DEALERSHIP_BRANDING: 'Branding Ads',
          OFFERS: 'Offer Ads'
        }
      : {
          LINK_CLICKS: 'Traffic Ads',
          VIDEO_VIEWS: 'Video Ads',
          LEAD_GENERATION: 'Lead Generation',
          PRODUCT_CATALOG_SALES: 'Dynamic Ads',
          CONVERSIONS: 'Site Visits',
          REACH: 'Reach Ads',
          MESSAGES: 'Messenger Ads',
          POST_ENGAGEMENT: 'Post Engagement',
          OUTCOME_TRAFFIC: 'Outcome Traffic',
          OUTCOME_SALES: 'Outcome Sales'
        };
    const url = window.location.href;

    if (!url.includes('/compliance')) {
      const accordionIndex = params.ad;
      if (accordionIndex !== '') {
        const indexes = Object.keys(campaignList).filter(
          (key) => campaignMonth[key].length > 0
        );
        const activeIndex = indexes.indexOf(params.campaign);
        this.setState({
          activeIndex,
          campaignKey: indexes[activeIndex]
        });
      } else {
        const indexes = Object.keys(campaignList).filter(
          (key) => campaignMonth[key].length > 0
        );
        this.setState({
          activeIndex: 0,
          campaignKey: indexes[0]
        });
      }
    } else {
      const { accordionIndex } = this.props;
      if (accordionIndex) {
        const campaigns = Object.keys(accordionIndex).filter(
          (key) => accordionIndex[key] !== -1
        );
        if (campaigns.length > 0 && campaigns[0] !== 'undefined') {
          const indexes = Object.keys(campaignList).filter(
            (key) => campaignMonth[key].length > 0
          );
          const activeIndex = indexes.indexOf(campaigns[0]);
          this.setState({ activeIndex, campaignKey: indexes[activeIndex] });
        } else {
          const indexes = Object.keys(campaignList).filter(
            (key) => campaignMonth[key].length > 0
          );
          this.setState({ activeIndex: 0, campaignKey: indexes[0] });
        }
      } else {
        const indexes = Object.keys(campaignList).filter(
          (key) => campaignMonth[key].length > 0
        );
        this.setState({ activeIndex: 0, campaignKey: indexes[0] });
      }
    }

    if (this.campaignTagContainer) {
      const { setCurrentCampaignForTable } = this.campaignTagContainer;
      if (setCurrentCampaignForTable) {
        setCurrentCampaignForTable(this.state.campaignKey);
      }
    }
  };

  processingCampaign = async () => {
    const { campaignMonth } = this.state;
    const { scrollToAccordion } = this.props;
    let loaderCount = 0;
    const campaignList = campaignMonth;
    const keys = Object.keys(campaignList);
    await Promise.all(
      _.map(keys, async (k) => {
        if (campaignMonth[k].length > 0) {
          const { newCampaignAds, count } = await this.processAdsAsync(
            campaignMonth[k]
          );
          // campaignMonth has undefined elements in each campaign. There are as many undefined elements as there were ads
          // in the previously selected month. For now, the undefined elements are filtered out here
          campaignList[k] = newCampaignAds.filter((ad) => {
            return ad !== undefined;
          });
          loaderCount += count;
          this.setState((prevState) => ({
            ...prevState,
            campaignMonth: campaignList,
            loaderCount
          }));
        }
      })
    );

    if (campaignRestructuringEnabled) {
      this.restructureCampaignsOnMount();
    } else {
      this.getTabActive();
      this.updateSelectedAds();
      this.processUpdatedQcForAllCampaigns(campaignMonth);
    }
    if (scrollToAccordion) scrollToAccordion();
  };

  processAdsAsync = async (adList) => {
    const { getFbToken, allAdsInfo } = this.props;
    let count = 0;
    const token = getFbToken();
    const buildedAds = await Promise.all(
      _.map(adList, async (ad) => {
        // this solution is temporary. sometimes, an error is thrown
        // that says creative is undef. this issue may be related to the
        // one mentinoned at line 152
        if (ad.creative) {
          const adData = allAdsInfo
            ? allAdsInfo.find((a) => a.adId === ad.id)
            : undefined;
          const buildAd = {
            ...ad,
            adData: adData ? adData.adData : undefined
          };
          count += 1;

          const adPreview = await buildAdPreviewObjectCompare(
            buildAd,
            '',
            token
          );
          return adPreview;
        }
      })
    );
    return {
      newCampaignAds: buildedAds,
      count
    };
  };

  campaignTagContainerRef = (ref) => {
    this.campaignTagContainer = ref;
  };

  handleTabChange = (e, data) => {
    const { panes, activeIndex } = data;
    const { campaignKey } = panes[activeIndex] || {};
    const {
      setUpdateUrl,
      adAccountName,
      selectedYear,
      campaignMonthName,
      allAdsExpanded
    } = this.props;
    if (setUpdateUrl) {
      updateUrl(
        adAccountName,
        selectedYear,
        campaignMonthName,
        '',
        campaignKey,
        '',
        allAdsExpanded || 'false'
      );

      if (this.campaignTagContainer) {
        const { setCurrentCampaignForTable } = this.campaignTagContainer;
        if (setCurrentCampaignForTable) {
          setCurrentCampaignForTable(campaignKey);
        }
      }
    }
  };

  updateSelectedAds = () => {
    const { campaignMonth, campaignRestructured } = this.state;
    const { actions } = this.props;
    const campaignList = campaignRestructured
      ? {
          MODEL_BASED: 'Model Ads',
          DEALERSHIP_BRANDING: 'Branding',
          OFFERS: 'Offer Ads'
        }
      : {
          LINK_CLICKS: 'Traffic Ads',
          VIDEO_VIEWS: 'Video Ads',
          LEAD_GENERATION: 'Lead Generation',
          PRODUCT_CATALOG_SALES: 'Dynamic Ads',
          CONVERSIONS: 'Site Visits',
          REACH: 'Reach Ads',
          MESSAGES: 'Messenger Ads',
          POST_ENGAGEMENT: 'Post Engagement',
          OUTCOME_TRAFFIC: 'Outcome Traffic',
          OUTCOME_SALES: 'Outcome Sales'
        };
    const selectedAds = {};
    Object.keys(campaignList).forEach((key) => {
      selectedAds[key] = campaignMonth[key].map((ad) => ({
        id: ad.ad_id,
        name: ad.ad_name,
        creative: ad.adObjective,
        facebookInfo: ad.facebookInfo,
        urls: {
          desktopUrl: ad.desktop_iframe_url,
          mobileUrl: ad.mobile_iframe_url
        }
      }));
    });
    actions.updateSelectedCustomAds(selectedAds);

    const url = window.location.href;
    if (!url.includes('/compliance')) {
      if (selectedAds.PRODUCT_CATALOG_SALES) {
        try {
          getEventSourceGroupName(selectedAds.PRODUCT_CATALOG_SALES).then(
            (results) => {
              this.setState({ eventGroupNames: results });
            }
          );
        } catch (error) {
          console.log('There were no event source group names to pull');
        }
      }
    }
  };

  toggleScrollButton = () => {
    try {
      if (document.querySelector('.sticky-button')) {
        if (document.querySelector('.App-content').scrollTop > 50) {
          document
            .querySelector('.sticky-button')
            .classList.remove('sticky-button-hidden');
          document
            .querySelector('.sticky-button')
            .classList.add('sticky-button-show');
        } else {
          document
            .querySelector('.sticky-button')
            .classList.remove('sticky-button-show');
          document
            .querySelector('.sticky-button')
            .classList.add('sticky-button-hidden');
        }
      }
    } catch (error) {
      console.log('Error with toggleScrollButton(): ', error);
    }
  };

  scrollToTop = () => {
    document.querySelector('.App-content').scrollTo({ top: 0, left: 0 });
  };

  renderDivider = (currentAd, nextAd, adTypes, campaignKey) => {
    try {
      const currentAdTypes = adTypes.filter((adType) =>
        currentAd.ad_name.toLowerCase().includes(adType.toLowerCase())
      );

      const currentAdType = getAdTypeOfAd(
        currentAd,
        currentAdTypes,
        campaignKey
      );

      const nextAdTypes = adTypes.filter((adType) =>
        nextAd.ad_name.toLowerCase().includes(adType.toLowerCase())
      );

      const nextAdType = getAdTypeOfAd(nextAd, nextAdTypes, campaignKey);

      const matchingAdTypes = currentAdType === nextAdType;

      return matchingAdTypes ? null : (
        <div>
          <Segment basic color="blue">
            <b>{nextAdType === '' ? 'Miscellaneous' : nextAdType} Ads</b>
          </Segment>
        </div>
      );
    } catch (error) {
      console.log('Error in renderDivider: ', error);
    }
  };

  renderAdTypeName = (ad, adTypes) => {
    const foundAdType = adTypes.find((adType) => ad.ad_name.includes(adType));
    return (
      <div>
        <Segment basic>
          <b>{foundAdType} Ads</b>
        </Segment>
      </div>
    );
  };

  updateUrls = (desktopUrl, mobileUrl, indexOfPreviewForUrls) => {
    this.setState({
      ...this.state,
      indexToUpdate: indexOfPreviewForUrls,
      desktopUrl,
      mobileUrl
    });
  };

  renderPreviews = (ads, campaignKey) => {
    const {
      getFbToken,
      campaignMonth,
      campaignMonthName,
      adAccountName,
      selectedYear,
      campaign_ids: campaignIds,
      utms,
      selectedAccounts,
      setUpdateUrl,
      sorting,
      allAdsInfo
    } = this.props;
    const {
      campaignMonth: campaignMonthState,
      campaignRestructured,
      desktopUrl,
      mobileUrl,
      indexToUpdate
    } = this.state;

    const adPatternKeys = Object.keys(adPatterns);
    const campaignKeyIndex = adPatternKeys.indexOf(campaignKey);
    const adTypes = campaignKeyIndex !== -1 ? adPatterns[campaignKey] : [''];

    const { eventGroupNames } = this.state;
    const sortedPreviews = sortAdsBy(ads, sorting, campaignKey, adTypes);
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    if (this.state.indexToUpdate > -1) {
      for (let i = 0; i < sortedPreviews.length; i += 1) {
        const preview = sortedPreviews[i];
        if (indexToUpdate === i) {
          preview.desktop_iframe_url = desktopUrl;
          preview.mobile_iframe_url = mobileUrl;
        }
      }
    }
    return (
      <Accordion>
        <Accordion fluid styled>
          {' '}
          {sortedPreviews.map((preview, index) => {
            const foundAdInfo = allAdsInfo
              ? allAdsInfo.find((adInfo) => {
                  return adInfo.adId === preview.ad_id;
                })
              : {};
            let esgName = '';
            try {
              const foundEsgObj = eventGroupNames
                ? eventGroupNames.find((esgObj) => {
                    return esgObj.ad_id === preview.ad_id;
                  })
                : {};

              if (foundEsgObj) {
                esgName = foundEsgObj.esgName;
              }
            } catch (error) {
              console.log(
                'Error with getting event source group name: ',
                error
              );
              esgName = '';
            }
            return (
              <div>
                {sorting === 'type'
                  ? index === 0
                    ? this.renderAdTypeName(preview, adTypes)
                    : null
                  : null}
                <PreviewAccordionItem
                  key={shortid.generate()}
                  adPreview={preview}
                  index={index}
                  campaignKey={campaignKey}
                  getFbToken={getFbToken}
                  campaignMonth={
                    campaignRestructured ? campaignMonthState : campaignMonth
                  }
                  campaignMonthName={campaignMonthName}
                  selectedAccounts={selectedAccounts}
                  adAccountName={adAccountName}
                  selectedYear={selectedYear}
                  selectedCampaign={params.campaign}
                  campaign_ids={campaignIds}
                  utms={utms}
                  setUpdateUrl={setUpdateUrl}
                  eventGroupName={esgName}
                  sorting={sorting}
                  adInfo={foundAdInfo}
                  renderAdsAfterQc={this.renderAdsAfterQc}
                  desktopUrl={desktopUrl}
                  mobileUrl={mobileUrl}
                  updateUrls={this.updateUrls}
                />
                {sorting === 'type'
                  ? index < sortedPreviews.length - 1
                    ? this.renderDivider(
                        sortedPreviews[index],
                        sortedPreviews[index + 1],
                        adTypes,
                        campaignKey
                      )
                    : null
                  : null}
              </div>
            );
          })}{' '}
        </Accordion>
        <Divider hidden />
      </Accordion>
    );
  };

  renderMenuItemTab = (campaignKey, campaignList) => {
    const { campaignMonth: campaignMonthProp } = this.state;
    const { campaignMonth, campaignRestructured } = this.state;
    return (
      <Menu.Item key={campaignKey}>
        <WrapperTabCheckbox
          campaignKey={campaignKey}
          campaignMonth={
            campaignRestructured ? campaignMonth : campaignMonthProp
          }
        />{' '}
        {campaignList[campaignKey]} <TabTotalAds campaignKey={campaignKey} />{' '}
      </Menu.Item>
    );
  };

  renderAdsAfterQc = (newAdsToSet, multiQc = false) => {
    const {
      showCheckboxesMultiQc,
      actions /* , scrollToAccordion */
    } = this.props;
    const newCampaignMonth = this.getCampaignMonthAfterQc(newAdsToSet);
    this.setState(
      (prevState) => ({
        ...prevState,
        campaignMonth: newCampaignMonth
      }),
      () => {
        if (showCheckboxesMultiQc) actions.displayMultiQcCheckbox();
        if (multiQc) {
          this.selectAllAdsInRedux();
          this.forceUpdate();
        }
      }
    );
  };

  getCampaignMonthAfterQc = (newAds) => {
    const { campaignMonth } = this.state;
    const tempCampaignMonth = { ...campaignMonth };
    const keys = Object.keys(tempCampaignMonth);
    keys.forEach((key) => {
      newAds.forEach((newAd) => {
        const {
          adQc: newAdQc,
          adNotes: newAdNotes,
          name: newAdOriginalName
        } = newAd;
        if (newAdQc) {
          const foundIndex = campaignMonth[key].findIndex((ad) => {
            return newAdQc.adId === ad.ad_id;
          });
          if (foundIndex !== -1) {
            tempCampaignMonth[key][foundIndex].adQc = newAdQc;
            tempCampaignMonth[key][foundIndex].adNotes = newAdNotes;

            if (newAdOriginalName) {
              tempCampaignMonth[key][
                foundIndex
              ].ad_original_name = newAdOriginalName;
              const newAdName = newAdOriginalName
                .toLowerCase()
                .includes(' -held')
                ? tempCampaignMonth[key][foundIndex].ad_name.concat(' -HELD')
                : tempCampaignMonth[key][foundIndex].ad_name.split(' -HELD')[0];

              tempCampaignMonth[key][foundIndex].ad_name = newAdName;
            }
          }
        } else {
          const { adNotes } = newAd;
          let adId = null;
          if (adNotes) adId = adNotes[0] ? adNotes[0].adId : null;
          if (adId) {
            const foundIndex = campaignMonth[key].findIndex((ad) => {
              return adId === ad.ad_id;
            });
            if (foundIndex !== -1) {
              tempCampaignMonth[key][foundIndex].adNotes = newAdNotes;
            }
          }
        }
      });
    });
    return tempCampaignMonth;
  };

  processUpdatedQcForAllCampaigns = (campaignMonth) => {
    const keys = Object.keys(campaignMonth);
    keys.forEach((key) => {
      this.processUpdatedQc(campaignMonth[key], key);
    });
    this.finishProcessing();
  };

  processUpdatedQc = (campaign, campaignKey) => {
    const { qcProcess, actions } = this.props;
    campaign.forEach((adPreview) => {
      if (adPreview.adQc && adPreview.adQc !== null) {
        if (adPreview.adQc.qc2 && adPreview.adQc.qc2 === 'true') {
          const qcAdsProgress = qcProcess;
          qcAdsProgress[campaignKey].totalQC =
            qcAdsProgress[campaignKey].totalQC + 1;
          const generalQCProgress = getGeneralQcProgess(qcAdsProgress);
          actions.updateTotalQCAds(qcAdsProgress, generalQCProgress);
        }
      }
    });
  };

  renderCampaignsTabs() {
    const {
      processing,
      loaderCount,
      campaignMonth,
      activeIndex,
      campaignRestructured
    } = this.state;
    const {
      allAdsInfo,
      adAccountName,
      selectedYear,
      campaignMonthName,
      allAdsExpanded
    } = this.props;
    const url = window.location.href;

    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    const { campaign: selectedCampaignKey, ad: selectedAccordionIndex } =
      params || {};

    const foundRestructuredCampaignKey = this.checkIfCampaignIsRestructured(
      selectedCampaignKey
    );

    if (!url.includes('/compliance')) {
      const urlParts = url.split('#');

      if (!urlParts[1]) {
        return null;
      }

      let accordionIndex = '';
      const campaignKey = selectedCampaignKey;
      if (selectedAccordionIndex) {
        accordionIndex = selectedAccordionIndex;
        if (!campaignRestructured && !foundRestructuredCampaignKey) {
          accordionIndex = selectedAccordionIndex;
        } else {
          accordionIndex = '';
          updateUrl(
            adAccountName,
            selectedYear,
            campaignMonthName,
            '',
            campaignKey,
            '',
            allAdsExpanded || 'false'
          );
        }
        if (
          accordionIndex &&
          campaignKey &&
          !campaignMonth[campaignKey][accordionIndex]
        ) {
          this.setState({
            showNoAdWarning: true
          });
        }
      }
    }

    if (processing) {
      return (
        <AdPreviewLoader
          loaderCount={loaderCount}
          loaderTotal={allAdsInfo.length}
          color="grey"
          size="tiny"
        />
      );
    }

    const campaignList =
      campaignRestructured || foundRestructuredCampaignKey
        ? {
            MODEL_BASED: 'Model Ads',
            DEALERSHIP_BRANDING: 'Branding',
            OFFERS: 'Offer Ads'
          }
        : {
            LINK_CLICKS: 'Traffic Ads',
            VIDEO_VIEWS: 'Video Ads',
            LEAD_GENERATION: 'Lead Generation',
            PRODUCT_CATALOG_SALES: 'Dynamic Ads',
            CONVERSIONS: 'Site Visits',
            REACH: 'Reach Ads',
            MESSAGES: 'Messenger Ads',
            POST_ENGAGEMENT: 'Post Engagement',
            OUTCOME_TRAFFIC: 'Outcome Traffic',
            OUTCOME_SALES: 'Outcome Sales'
          };

    const tabs = Object.keys(campaignList)
      .filter((key) => campaignMonth[key].length > 0)
      .map((key) => ({
        menuItem: this.renderMenuItemTab(key, campaignList),
        pane: (
          <Tab.Pane key={shortid.generate()}>
            {' '}
            {this.renderPreviews(campaignMonth[key], key)}{' '}
          </Tab.Pane>
        ),
        campaignKey: key
      }));

    return (
      <div>
        <Tab
          renderActiveOnly={false}
          defaultActiveIndex={activeIndex}
          panes={tabs}
          onTabChange={this.handleTabChange}
        />
      </div>
    );
  }

  renderQcProgressSegment = () => {
    return (
      <div>
        <Segment>
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={5} verticalAlign="middle">
                <Label color="green" ribbon>
                  QC Progress
                </Label>
              </Grid.Column>
              <Grid.Column width={11}>
                <AdQCProgressBar />{' '}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
        <Divider hidden />
      </div>
    );
  };

  renderCommonTools = () => {
    const { campaignRestructured, processing } = this.state;
    const { getFbToken } = this.props;
    const adPreviewMultiQc = (
      <AdPreviewMultiQc
        getFbToken={getFbToken}
        processing={processing}
        updateParentState={this.renderAdsAfterQc}
        resetReduxSelectedAds={this.resetReduxSelectedAds}
        selectAllAdsInRedux={this.selectAllAdsInRedux}
      />
    );
    return (
      <ToggleComponents
        processing={processing}
        resetReduxSelectedAds={this.resetReduxSelectedAds}
        selectAllAdsInRedux={this.selectAllAdsInRedux}
        adPreviewMultiQc={adPreviewMultiQc}
        campaignRestructured={campaignRestructured}
        restructureCampaigns={this.restructureCampaigns}
      />
    );
  };

  getCampaignKey = () => {
    const { campaignKey, campaignMonth } = this.state;
    const campaignKeyToUse =
      campaignKey.trim() !== ''
        ? campaignKey
        : Object.keys(campaignMonth).find(
            (key) => campaignMonth[key].length > 0
          );
    return campaignKeyToUse;
  };

  render() {
    const { showNoAdWarning } = this.state;
    const { campaignTagsObjects } = this.props;
    const campaignKey = this.getCampaignKey();

    return (
      <div className="campaigns-container">
        <CampaignTagsContainer
          onRef={(ref) => this.campaignTagContainerRef(ref)}
          campaignTagsObjects={campaignTagsObjects}
          campaignKey={campaignKey}
        />
        {this.renderQcProgressSegment()}
        {showNoAdWarning ? (
          <div className="campaigns-container-warning">
            The ad you are trying to open does not exist{' '}
          </div>
        ) : null}{' '}
        {this.renderCampaignsTabs()}{' '}
        <AdPreviewCommonToolsSidebar
          renderSidebarContent={this.renderCommonTools}
          scrollToTop={this.scrollToTop}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { adQc, adPreview } = state;
  return {
    qcProcess: adQc.qcProcess,
    selectedAds: adPreview.selectedAds,
    checkedCampaigns: adPreview.checkedCampaigns,
    indeterminateCampaigns: adPreview.indeterminateCampaigns,
    showCheckboxes: adPreview.showCheckboxes,
    showCheckboxesMultiQc: adPreview.showCheckboxesMultiQc,
    allAdsExpanded: adPreview.expandAllAds
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabCampaignsComponent);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/TabCampaignsComponent.js